import React from 'react';

const InputError = (props) => (
	<div className={'validation-' + props.errorClass}>
		<span>{props.errorMessage}</span>
	</div>
);


InputError.propTypes = {  

};

export default InputError;


// WEBPACK FOOTER //
// ./src/components/formComponents/InputError.js